import { Maybe } from "true-myth";
import { map, takeLast, head, equals } from "ramda";
import { Money } from "@upserve/financials";
import { getPrettyUrl } from "get_base_uri";
import { findCardTypeByFirstDigit } from "helpers/credit_cards";
import { toNullable } from "helpers/maybe";
export function transformCheckInfoApiResponse(apiResponse) {
    var payments = map(function (payment) {
        return {
            id: payment.id,
            amount: Money.fromDollars(payment.amount),
            tipAmount: Money.fromDollars(payment.tipAmount),
            tenderName: payment.tenderName,
            cardType: Maybe.of(payment.cardType),
            lastFourDigits: Maybe.of(payment.lastFourDigits),
        };
    }, apiResponse.payments);
    return {
        balanceDue: Money(apiResponse.balanceDue),
        checkCompTotal: apiResponse.checkCompTotal
            ? Money(apiResponse.checkCompTotal)
            : Money(0),
        checkId: apiResponse.checkId,
        checkName: apiResponse.checkName,
        checkNumber: apiResponse.checkNumber,
        checkType: apiResponse.checkType,
        createdAt: apiResponse.createdAt,
        deviceId: Maybe.of(apiResponse.deviceId),
        mandatoryTip: Maybe.of(apiResponse.mandatoryTip),
        mandatoryTipAmount: apiResponse.mandatoryTipAmount
            ? Money(apiResponse.mandatoryTipAmount)
            : Money(0),
        netTotal: Money(apiResponse.netTotal),
        payments: payments,
        serverId: Maybe.of(apiResponse.serverId),
        serverName: apiResponse.serverName,
        subtotalBeforeComp: Money(apiResponse.subtotalBeforeComp),
        tax: Money(apiResponse.tax),
        total: Money(apiResponse.total),
    };
}
export function getNothingFromEmptyStringOrNull(input) {
    return Maybe.of(input.match({
        Just: function (value) { return (equals("", value) ? null : value); },
        Nothing: function () { return null; },
    }));
}
export function transformMerchantInfoApiResponse(apiResponse) {
    var transformedResponse;
    if ("redirectPrettyUrl" in apiResponse) {
        transformedResponse = {
            redirectPrettyUrl: apiResponse.redirectPrettyUrl,
        };
    }
    else {
        transformedResponse = {
            ugMerchantKey: apiResponse.ugMerchantKey,
            prettyUrl: apiResponse.prettyUrl,
            name: apiResponse.name,
            streetLine1: apiResponse.streetLine1,
            streetLine2: getNothingFromEmptyStringOrNull(Maybe.of(apiResponse.streetLine2)),
            locality: apiResponse.locality,
            region: apiResponse.region,
            postalCode: apiResponse.postalCode,
            phone: apiResponse.phone,
            suggestedTipPercentLow: typeof apiResponse.suggestedTipPercentLow === "string"
                ? parseFloat(apiResponse.suggestedTipPercentLow)
                : apiResponse.suggestedTipPercentLow,
            suggestedTipPercentMiddle: typeof apiResponse.suggestedTipPercentMiddle === "string"
                ? parseFloat(apiResponse.suggestedTipPercentMiddle)
                : apiResponse.suggestedTipPercentMiddle,
            suggestedTipPercentHigh: typeof apiResponse.suggestedTipPercentHigh === "string"
                ? parseFloat(apiResponse.suggestedTipPercentHigh)
                : apiResponse.suggestedTipPercentHigh,
            mobilePaymentsStatus: apiResponse.mobilePaymentsStatus,
            customTipsEnabled: apiResponse.customTipsEnabled,
            suggestedTipDefault: apiResponse.suggestedTipDefault,
            showSuggestedTips: apiResponse.showSuggestedTips,
        };
    }
    return transformedResponse;
}
export function transformCardForRegistry(cardInfo, paymentMethodToken) {
    return {
        firstName: cardInfo.firstName,
        lastName: cardInfo.lastName,
        paymentMethodToken: paymentMethodToken,
        lastFour: takeLast(4, cardInfo.cardNumber),
        nameOnCard: cardInfo.firstName + " " + cardInfo.lastName,
        cardType: findCardTypeByFirstDigit(head(cardInfo.cardNumber)).prettyName.toLowerCase(),
        storePrettyUrl: getPrettyUrl(),
    };
}
export function transformCardForProcessing(checkInfo, total, balanceDue, cardId, cardInfo, consumerId, tip, submissionId) {
    return {
        checkId: checkInfo.checkId,
        email: cardInfo.email,
        phone: cardInfo.phone,
        total: total.valueOf(),
        balanceDue: balanceDue.valueOf(),
        submissionId: submissionId,
        payment: {
            amount: total.add(tip).valueOf(),
            cardUuid: cardId,
            consumerUuid: consumerId,
            cvv: cardInfo.cvv,
            deviceId: toNullable(checkInfo.deviceId),
            firstName: cardInfo.firstName,
            lastName: cardInfo.lastName,
            serverId: toNullable(checkInfo.serverId),
            tipAmount: tip.valueOf(),
        },
    };
}
export function transformCreditCardPaymentApiResponse(apiResponse) {
    return {
        total: Money(apiResponse.total),
        balanceDue: Money(apiResponse.balanceDue),
        email: apiResponse.email,
        payment: {
            id: apiResponse.payment.id,
            amount: Money(apiResponse.payment.amount),
            tipAmount: Money(apiResponse.payment.tipAmount),
            tenderName: "Credit Card",
            cardType: Maybe.nothing(),
            lastFourDigits: Maybe.nothing(),
        },
    };
}
